import _ from 'lodash'

export const MEDIA_TYPES = [
  {value: 1, name: 'Youtube'},
  {value: 2, name: 'Image'}
]

export const VIDEO_CATEGORIES = [
  {value: 1, name: 'Music Video'},
  {value: 2, name: 'Document'},
  {value: 3, name: 'Live'},
  {value: 4, name: 'Trailer'},
  {value: 5, name: 'Other'}
]

export const toName = (array, value) => {
  if (!array || !value) return ''

  value = _.toSafeInteger(value)
  let found = _.find(array, {value})
  return (found.name) ? found.name : value
}




// WEBPACK FOOTER //
// ./src/consts.js